import regexConfig from '../config/regex';

const emailField = (html) => {
  const regex = regexConfig.EMAIL_FIELD;

  return regex.test(html);
};

export default emailField;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/validations/emailField.js
 **/